import ClassOperation from '@/api/class-operation'
import Staff from '@/api/home/staff'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  classes: [],
  class_id: [],
  date_from: moment()
    .add(-1, 'Month')
    .format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM(state, date) {
    state.date_from = date
  },
  SET_DATE_TO(state, date) {
    state.date_to = date
  },
  SET_CLASSES(state, data) {
    state.classes = data
  },
  SET_CLASS_ID(state, data) {
    state.class_id = data
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    let params = Object.assign({
      page: context.state.pagination.page,
      perPage: context.state.pagination.perPage,
      search: context.state.search,
      date_from: context.state.date_from,
      date_to: context.state.date_to,
      class_id: context.state.class_id,
      ...attributes
    })
    return Staff.getPaymentHistory({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  fetchClasses(context) {
    return ClassOperation.get({
      params: {
        page: -1,
        fields: {
          academic_classes: 'class_id,class_name'
        }
      }
    }).then(response => {
      context.commit('SET_CLASSES', response.data)
      return Promise.resolve(response)
    })
  }
}
